export const PhoneTwo = (celular: string) =>
  celular &&
  celular.replace(/^(\d{2})(\d{2})(\d{5}|\d{4})(\d{4})/gm, "+$1 $2 $3-$4");

export const formatCEP = (cep: string) =>
  cep && cep.replace(/^(\d{5})(\d{3})/, "$1-$2");

export const removeLetters = (value: string) => {
  value = value.replace(/\D/g, "");
  return value;
};

// export const formatUF = (uf: string) =>
//   uf &&
//   uf.replace(
//     /^(?i)(\s*(AC|AL|AP|AM|BA|CE|DF|ES|GO|MA|MT|MS|MG|PA|PB|PR|PE|PI|RJ|RN|RS|RO|RR|SC|SP|SE|TO)?)$/,
//     "$1"
//   );
